let securityKey = null
let recaptchaSiteKey = null

export const setSecurityKey = (key) => {
  if (key) {
    securityKey = key
  }
}

export const setRecaptchaSiteKey = (key) => {
  if (key) {
    recaptchaSiteKey = key
  }
}

export const getSecurityKey = () => securityKey
export const getRecaptchaSiteKey = () => recaptchaSiteKey
